import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GasprecioService } from '../../../gasprecio/services/gasprecio.service';
import { SharedService } from '../../../gasprecio/services/shared.service';
import Highcharts from 'highcharts';
import moment from 'moment';

@Component({
  selector: 'app-chart-margin-dashboard2',
  templateUrl: './chart-margin-dashboard2.component.html',
  styleUrls: ['./chart-margin-dashboard2.component.scss']
})
export class ChartMarginDashboard2Component implements OnInit, OnDestroy {

  @Input() name: string;
  @Input() type: string = 'accumulated';
  @Input() isGroup: boolean = true;
  date: any;
  first = true;
  format$!: Subscription
  format: number;
  Highcharts: typeof Highcharts = Highcharts;
  idGroup = '60afa99655f4ee369d1df409';
  idGroup$!: Subscription;
  productType = 'regular';
  productType$!: Subscription;
  purchasePrice: any;
  reqst = 0;
  rol;
  sellingPrice;
  showBurgos = false;
  showYAxis = false;
  showRendichicas = false;
  showCombuexpress = false;
  showEnerser = false;
  showMobico = false;
  showMegagas = false;
  showRuta = false;
  specialGroup = false;
  stationSelected$!: Subscription;
  stationSelected: string = localStorage.getItem("idStation");
  t;
  t$: Subscription;;
  t_1;
  t_1$: Subscription;
  t_2;
  t_2$: Subscription;
  year = false;
  zoneSelected = null;
  zoneSelected$: Subscription;
  selectedCluster2: number | null = null;
  selectedCluster2$!: Subscription;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        y: 14
      }
    },
    yAxis:
    {
      title: {
        text: '',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        format: '$ {value:.2f}',
        // formatter: function(){
        //   return this.value.toLocaleString('es-MX');
        // },
        style: {
          fontSize: '11px'
        }
      },
      tickAmount: 6,
      gridLineDashStyle: 'LongDash',
    },
    legend: {
      enabled:false
    },
    tooltip: {
      split: true,
      pointFormat: 'Margen: <b>$ {point.y:.2f}</b>'
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 2
        },
        lineWidth: 2,
        dataLabels: {
          enabled: true,
          inside: false,
          formatter: function () {
            return `$ ${Highcharts.numberFormat(this.y, 2, '.', ',')}`;
          },
          style: {
            fontSize: '11px',
            fontWeight: 'bold'
          }
        }
      }
    },
    exporting: {
      filename: ``,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -10
      }
    },
    series: []
  };

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService,
  ) {
    this.rol = localStorage.getItem('rol');

    this.productType$ = this.sharedService.sharedProductTypeDashboard2.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
          this.setData();
        }
      }
    });

    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        if (this.reqst > 1) {
          this.zoneSelected = '';
          this.getDashboardSellingPricePurchase();
        }
      }
    });
    this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
    this.showCombuexpress = this.idGroup === '63fd4c8f1a5bfd390727f392' ? true : false;
    this.showMobico = this.idGroup === '6697df2bfb7789085d7d82b4' ? true : false;
    this.showMegagas = this.idGroup === '666cb6528c251f2c5d6204b5' ? true : false;
    this.showRuta = this.idGroup === '668eaeceec578636ce2a789a' ? true : false;
    this.showEnerser = this.idGroup === '643f507358715227618de808' || this.idGroup === '649216f6edc3bad5497001f9' ? true : false;
    this.showBurgos = this.idGroup === '652089ad94a59a35e91437da' || this.idGroup === '65c2849672bf4238ffccbe4c' ? true : false;
    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
        this.showCombuexpress = this.idGroup === '63fd4c8f1a5bfd390727f392' ? true : false;
        this.showRuta = this.idGroup === '668eaeceec578636ce2a789a' ? true : false;
        this.showMobico = this.idGroup === '6697df2bfb7789085d7d82b4' ? true : false;
        this.showMegagas = this.idGroup === '666cb6528c251f2c5d6204b5' ? true : false;
        this.showEnerser = this.idGroup === '643f507358715227618de808' || this.idGroup === '649216f6edc3bad5497001f9' ? true : false;
        this.showBurgos = this.idGroup === '652089ad94a59a35e91437da' || this.idGroup === '65c2849672bf4238ffccbe4c' ? true : false;
      }
    });

    this.specialGroup = this.showBurgos || this.showRendichicas || this.showCombuexpress

    this.stationSelected$ = this.sharedService.sharedStation.subscribe((idStation) => {
      if (idStation && idStation !== this.stationSelected) {
        this.stationSelected = idStation;
        this.getDashboardSellingPricePurchase();
      }
    });

    this.zoneSelected$ = sharedService.sharedZone.subscribe((zone: string) => {
      if (this.showRendichicas && zone === null) {
        this.zoneSelected = '6178671b46818a57510e9218';
      } else if (this.showEnerser && zone === null && this.idGroup === '643f507358715227618de808') {
        this.zoneSelected = '651b4288b13c717f2fcd775b';
      } else if (this.showEnerser && zone === null && this.idGroup === '649216f6edc3bad5497001f9') {
        this.zoneSelected = '64d2d15f8bd81e4d428e7797';
      } else if (this.showBurgos && zone === null) {
        this.zoneSelected = '6525737f03da8cde44820771';
      } else if (this.showMobico && zone === null) {
        this.zoneSelected = '6697e639fb7789085d7f7012';
      } else if (this.showMegagas && zone === null) {
        this.zoneSelected = '666cb9c38c251f2c5d622283';
      } else if (this.showRuta && zone === null) {
        this.zoneSelected = '668eb65057ab5f397ef9f2df';
      } else if ((!this.showRendichicas && zone === null) || (!this.showCombuexpress && zone === null) || (!this.showCombuexpress && zone === null)) {
        this.zoneSelected = '';
      } else {
        this.zoneSelected = zone;
      }
      if (this.reqst > 1) {
        this.stationSelected = '';
        this.getDashboardSellingPricePurchase();
      }
    });

    this.format$ = sharedService.sharedDashboardComparativeShown.subscribe((format: number) => {
      this.format = format
    });

    this.t$ = sharedService.sharedTDashboard2.subscribe((date: string) => {
      const formattedDate = (date.match(/-/g) || []).length === 1 ? `${date}-01` : date;

      if (formattedDate !== this.t) {
        this.t = formattedDate;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePurchase();
        }
      }
    });

    this.t_1$ = sharedService.sharedT1Dashboard2.subscribe((date: string) => {
      const formattedDate = (date.match(/-/g) || []).length === 1 ? `${date}-01` : date;

      if (formattedDate !== this.t_1) {
        this.t_1 = formattedDate;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePurchase();
        }
      }
    });

    this.t_2$ = this.sharedService.sharedT2Dashboard2.subscribe((date: string | null) => {
      if(!date){
        this.t_2 = null;
        if (this.reqst > 1) this.getDashboardSellingPricePurchase();
        return;
      }

      const formattedDate = (date.match(/-/g) || []).length === 1 ? `${date}-01` : date;
      if (formattedDate !== this.t_2) {
        this.t_2 = formattedDate;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePurchase();
        }
      }
    });

    this.selectedCluster2$ = this.sharedService.sharedSelectedComplementClusters2.subscribe((selectedCluster2: number | null) => {
      if (selectedCluster2 !== this.selectedCluster2) {
        this.selectedCluster2 = selectedCluster2;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePurchase();
        }
      }
    });
  }

  ngOnInit() {
    this.getDashboardSellingPricePurchase();
  }

  ngOnDestroy(): void {
    this.idGroup$.unsubscribe();
    this.productType$.unsubscribe();
    this.stationSelected$.unsubscribe();
    this.t$.unsubscribe();
    this.t_1$.unsubscribe();
    this.t_2$.unsubscribe();
    this.zoneSelected$.unsubscribe();
    this.selectedCluster2$.unsubscribe();
  }

  getDashboardSellingPricePurchase() {
    if(this.isGroup){
      if(this.first){
        this.stationSelected = 'zone';
        this.first = false;
      }
    }else{
      this.stationSelected = localStorage.getItem("idStation");
    }
    this.stationSelected == 'zone' ? this.stationSelected = '' : this.stationSelected;
    this.reqst = 1;
    const url = this.t_2 ? this.gasprecioService.getComparativeDashboardMargin(this.idGroup, this.stationSelected, this.type, this.zoneSelected, this.t_2, this.t_1, this.t, this.selectedCluster2) : this.gasprecioService.getComparativeDashboardMargin(this.idGroup, this.stationSelected, this.type, this.zoneSelected, this.t_1, this.t, undefined, this.selectedCluster2);
    // const url = this.gasprecioService.getComparativeDashboardMargin(this.idGroup, this.stationSelected, this.type, this.t_2, this.t_1, this.t, this.zoneSelected);
    if(this.t){
      url.subscribe({
        next: (data: any) => {
          this.sellingPrice = data.data;
          this.setData();
        }, complete: () => {
          this.reqst = 2;
        }, error: () => {
          this.reqst = 3;
        }
      });
    }
  }

  setData() {
    this.reqst = 1;
    const color = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);

    let sellingPriceChartData: any;
    sellingPriceChartData = {
      name: '',
      data: this.sellingPrice.map((v: any) => {
        return v[this.productType] === null ? null : +v[this.productType];
      }),
      color: color,
      lineWidth: 2,
      marker: { radius: 2 },
      pointWidth: 25,
      dataLabels: {
        style: { fontSize: '10' }
      },
      yAxis: 0
    };

    const lineXaxisLegend = this.sellingPrice.map((v: any, i: number) => this.formatDate(v.date, i));
    this.chartOptions['xAxis']['categories'] = lineXaxisLegend;
    this.chartOptions.series = [sellingPriceChartData];
    setTimeout(() => {
      this.reqst = 2;
      this.sharedService.nextChartLoadedNotification = `chart-margin-${this.type}`;
    }, 100);
  }

  generateImageChart() {
    const canvas1: any = document.getElementById('mychart1');
    const imgData1 = canvas1.toDataURL('image/png');
    this.sharedService.nextImgData1 = imgData1;
  }

  formatDate(dateISO: string, index: number): string {
    const actualDate = moment.tz('America/Mexico_City');
    const date = moment.tz(dateISO, 'America/Mexico_City');
    // const isYear = this.specialGroup;

    // if (isYear) {
    //   const monthName = date.locale('es').format('MMMM');
    //   const capitalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1);
    //   const year = date.format('YY');

    //   return `${capitalizedMonth} ${year}`;
    // }

    const dateName = date.format('MMM').replace('.', '').toUpperCase();
    // const showToday = date.isSame(actualDate, 'month') && this.type !== 'monthly';
    const showToday = this.type !== 'monthly';
    const lastDay = showToday ? actualDate.clone().subtract(1, 'day').date() : date.endOf('month').date();

    return `${dateName} 1 - ${lastDay}`;
  }

  formatName(type){
    const names = {
      'accumulated': 'Acumulado (hoy)',
      'monthly': 'Mensuales (cierre mes)',
      'daily_avg': 'Prom Diario'
    }
    return names[type];
  }
}
